import storeSubscribe from "../store/subscribe";

const [setPlaylists] = storeSubscribe("playlists", (playlists) => { });

let bound = false;

// The store holds the list the screens render; the service owns it. Every committed change reaches the store,
// and nothing reaches the store that wasn't committed.
export const bindPlaylistsToStore = (service) => {

    if (bound) return;

    bound = true;

    service.subscribe((playlists) => setPlaylists(playlists));

};

// Waits for the service and publishes what it holds. Opening the playlists page is the moment to try again
// if the store couldn't start.
export const syncPlaylistsToStore = async (service) => {

    const status = await service.init();

    if (status.state === "unavailable") await service.retryInit();

    setPlaylists(service.getAll());

};
